import { getName, getLink } from 'peach/helpers'

import { R } from 'core/helpers'
import { useInternalEmployeesGetPaged } from 'core/types'
import { InternalEmployeesGetVariables } from 'core/types/operations'

type UseEmployeeAppSearchProps = {
  query?: InternalEmployeesGetVariables['query']
  options?: { [key: string]: unknown }
  companyId?: string
}

const useEmployeeAppSearch = ({
  query,
  options,
  companyId,
}: UseEmployeeAppSearchProps) => {
  const employeeQuery = useInternalEmployeesGetPaged({
    companyId,
    options: { enabled: !!companyId, ...(options ?? {}) },
    query,
  })

  const { data: people } = employeeQuery

  const results = R.map(people ?? [], (person) => ({
    group: 'Employees',
    label: getName(person),
    to: getLink(person),
    subtitle: 'Employee',
    id: person.id,
  }))

  return { ...employeeQuery, options: results }
}

export default useEmployeeAppSearch
